export default __webpack_public_path__ + "d24d054e1e7e6aa0fee89df3e5d5dcef.png";